export default __webpack_public_path__ + "static/media/video2.cb6a1166.webp";